import { useEffect, useState } from 'react';

import get from 'lodash/get';
import useSWR from 'swr';

import { getPersistentVolumeClaims } from '../capabilities/maas-model-storage/api/persistentVolumeClaims';

interface PersistentVolumeClaim {
  value: string;
  label: string;
  namespace: string;
  accessModes: string[];
  storage: string;
  description?: string;
}

function getPvcDescription(item: unknown): string {
  const annotations = get(item, 'metadata.annotations') as Record<string, string> | undefined;
  return String(get(annotations, 'stack.io/description') || get(annotations, 'stack.io/describe') || '').trim();
}

/** MaaS 数据盘选择：共享 PVC 下拉选项 */
export const usePersistentVolumeClaims = (params?: Record<string, unknown>) => {
  const [options, setOptions] = useState<PersistentVolumeClaim[]>([]);

  const { data: response, isLoading } = useSWR({ key: 'Maas.PERSISTENT_VOLUME_CLAIM', params }, () => getPersistentVolumeClaims());

  useEffect(() => {
    if (response) {
      const { totalItems, items } = response as { totalItems?: number; items?: unknown[] };
      if ((totalItems ?? 0) > 0 && Array.isArray(items)) {
        const pvcOptions = items.map((item) => ({
          value: get(item, 'metadata.name'),
          label: get(item, 'metadata.annotations.["stack.io/aliase"]') || get(item, 'metadata.name'),
          namespace: get(item, 'metadata.namespace'),
          accessModes: get(item, 'spec.accessModes'),
          storage: get(item, 'status.capacity.storage'),
          description: getPvcDescription(item),
        }));
        setOptions(pvcOptions);
      }
    }
  }, [response]);

  return { options, isLoading };
};
